// In-editor combat playtest: validation.
//
// Deliberately thin. Studio's `MapDocument` is structurally assignable to
// `@sstk/sunder-sim`'s `MapDocumentInput` (verified at compile time by
// `src/engine/content/schema/_sunder-compat.ts`), so there is no conversion
// step to write or duplicate here - the live editor document is passed to
// the sim's own validator unchanged.
//
// This intentionally does NOT reuse Studio's own `lintMap` (src/engine/
// editor/validation/mapLinter.ts): that linter only checks that each team
// has *at least one* spawn marker, while the sim's real `validateMapDocument`
// requires at least `MAX_TEAM_ROSTER_SIZE` per team (see its own doc
// comment). A map can pass Studio's save-time lint and still be rejected
// here - that gap is pre-existing and belongs to `mapLinter.ts`, not this
// feature; the playtest gate must reflect what the sim will actually accept
// when a match starts, not a looser approximation of it.
import { validateMapDocument, type GameMode, type MapProblem } from '@sstk/sunder-sim';
import type { MapDocument } from '../../engine';

export interface PlaytestValidation {
  ok: boolean;
  problems: MapProblem[];
}

/** Validate the live editor document against Sunder's own completeness rules. */
export function validatePlaytestDocument(document: MapDocument): PlaytestValidation {
  return validateMapDocument(document);
}

/**
 * The game mode a playtest should run: the document's own first declared
 * supported mode, or the historical default (full objective play) when the
 * field is unset. Keeps a Strike/Surge-only map from being force-started in
 * a mode it never claims to support.
 */
export function resolvePlaytestGameMode(document: MapDocument): GameMode {
  return document.supportedModes?.[0] ?? 'rift-tactical';
}
